import { SxProps, Theme } from '@mui/material/styles'
import { FC, ReactNode } from 'react'

import Box from '@mui/material/Box'
import { GRAY_700, GRAY_900 } from 'constants/styling/theme'
import Stack from '@mui/material/Stack'

interface Props {
  /** Field label */
  label?: string
  /** Field value - component auto-hides when value is falsy and no children provided */
  value?: ReactNode
  /** Force hide the field */
  hidden?: boolean
  /** Custom sx styles */
  contentSx?: SxProps<Theme>
  /** Children to render instead of value */
  children?: ReactNode
}

/**
 * Label-value pair for assignment detail drawer. Auto-hides when value is empty.
 * @example
 * <DetailField label="Room type" value="Living room" />
 * <DetailField label="Style" value={null} /> // hidden automatically
 */
export const DetailField: FC<Props> = ({ label, value, hidden, contentSx, children }) => {
  const content = children ?? value
  if (hidden || (!content && content !== 0)) return null

  return (
    <Stack fontSize="1.4rem" paddingBottom="1.6rem">

      {!!label &&
        <Box
          fontWeight={500}
          color={GRAY_700}
          marginBottom=".2rem"
          lineHeight="2rem"
        >
          {label}
        </Box>
      }

      <Box fontSize="1.6rem" fontWeight={350} lineHeight="2.4rem" color={GRAY_900}  sx={contentSx}>
        {content}
      </Box>

    </Stack>
  )
}
